import React, { useState, useEffect } from "react";
import { Button, Form, Input, Card} from "reactstrap";
import logoCiba from "../../assets/images/logo.png";
import { updatePass, getUsuario } from "../../services/api"
import { useHistory } from "react-router";

const initialState = { 
  dni: "", 
  msg: "", 
  socio: null, 
  email: null, 
  celular: null
}

const RecuperoToken = () => {
  const [state, setState] = useState(initialState)
  const [paso, setPaso] = useState(1)
  const history = useHistory()

  const handleInputChange = async (event) => {
    const target = event.nativeEvent.target;
    const name = target.name;
    const value = target.value;
    await setState({...state,
      [name]: value,
      msg:''
    });

  }

  const handlequery = () => {
    return new URLSearchParams(window.location.hash.split("?")[1]);
  };

  useEffect(() => {
    const handleToken = async () => {
      var dni = handlequery().get("d");
      var codigo = handlequery().get("c");
        const socio = await getUsuario(dni);
        if(socio.codigo_sms.toString() === codigo.toString()){
            setState({...state, dni, email: socio.email, socio})
            setPaso(4)
        }else{
          console.log('los codigos NO coinciden')
          setPaso(6)
        }
    }
      handleToken()
  }, [setState, setPaso, state.dni])

  const handleConfirmRegistro = async (event) => {
    event.preventDefault();
    const response = await updatePass(state)
    if(response.status === 200){
      setPaso(5)
    }else{
      setPaso(3)
    } 
    
  }

  const handleRedirect = () => {
    var url = handlequery().get("app");
    if(url){
      window.location.href = url;
    }else{
      history.push('/')
    }
  }
  
  const { msg, password, passwordRepeat } = state;

  return (
    <>
      <img src={logoCiba} className="logoCiba mt-5" alt=""  />
      <Card className="p-4 text-center mt-4">
        <p className="mt-2 title"> INGRESAR NUEVA CONTRASEÑA</p>
        {paso === 3 ? 
          <>
            <p className='my-5 pt-2'>Ha ocurrido un error, intente por farvor más tarde</p>
            <Button 
              className="btn btn-continuar" 
              onClick={handleRedirect}
            >
              Volver
            </Button>
          </>
        : paso === 4 ? 
          <Form onSubmit={handleConfirmRegistro}>
            <p className="mt-5"></p>
            <p>
              <Input
                name="password"
                placeholder="PASSWORD"
                type="password"
                className="inputDni"
                onChange={handleInputChange}
              />
            </p>
            <p>
              <Input
                name="passwordRepeat"
                placeholder="CONFIRMAR PASSWORD"
                type="password"
                className="inputDni"
                onChange={handleInputChange}

              />
            </p>
            <Button className="btn btn-continuar" type="submit" disabled={ !password || password.length < 6 || passwordRepeat !== password}>
              Continuar
            </Button>
            <p>{msg}</p>
          </Form>
        : paso === 5 ? 
          <>
            <p className='my-5 pt-2'>Se cambió la contraseña correctamente</p>
            <Button className="btn btn-continuar" onClick={handleRedirect}>
              Ingresar
            </Button>
          </>
        : paso === 6 ?
          <>
            <p className='my-5 pt-2'>El enlace no es válido o ya expiró</p>
            <Button className="btn btn-continuar" onClick={handleRedirect}>
              Volver
            </Button>
          </>
        : <p className='my-5 pt-2'>Validando...</p>}
      </Card>
    </>
  );
  
}


export default RecuperoToken;
